export default __webpack_public_path__ + "static/media/mobile-mockup.53d8b55c.png";